import type { IConfigurationRepository } from '../repositories/IConfigurationRepository.js';

export function createDeleteConfigurationUseCase({ configurationRepository }: { configurationRepository: IConfigurationRepository }) {
  return (id: string) => configurationRepository.delete(id);
}
